import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./yieldSummaryTableCompare.module.scss";

const YieldSummaryTableCompare = ({ dataObject, dataObject2 }) => {
  const { t } = useTranslation();

  if (!dataObject) {
    return null;
  }

  const rows = [
    {
      label: t("portfolio.distribuzioneProventi"),
      portfolio1: dataObject.monthly_distribution
        ? dataObject.monthly_distribution.toFixed(2).replace(".", ",")
        : "2,34",
      portfolio2: dataObject2?.monthly_distribution
        ? dataObject2.monthly_distribution.toFixed(2).replace(".", ",")
        : "1,81",
    },
    {
      label: t("portfolio.yieldToMaturity"),
      portfolio1: dataObject.ytm_total
        ? dataObject.ytm_total.toFixed(2).replace(".", ",")
        : "3,85",
      portfolio2: dataObject2?.ytm_total
        ? dataObject2.ytm_total.toFixed(2).replace(".", ",")
        : "6,93",
    },
    {
      label: t("portfolio.durationAnni"),
      portfolio1: dataObject.duration_total
        ? dataObject.duration_total.toFixed(2).replace(".", ",")
        : "3,40",
      portfolio2: dataObject2?.duration_total
        ? dataObject2.duration_total.toFixed(2).replace(".", ",")
        : "6,60",
    },
  ];

  return (
    <div className={styles.tableContainer}>
      <table className={styles.compareTable}>
        <thead>
          <tr>
            <th></th>
            <th>Portafoglio 1</th>
            <th>Portafoglio 2</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => (
            <tr key={index}>
              <td>{row.label}</td>
              <td>{row.portfolio1}</td>
              <td>{row.portfolio2}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default YieldSummaryTableCompare;
